import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportSalesByNoteTypes } from "redux/reducers/Reports/reportSalesByNote/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_SALES_BY_NOTE_FILTERS } = reportSalesByNoteTypes;

export const getReportSalesByNoteAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    dispatch(startRequestComp('loadingSalesByNote'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/notes/sale-by-note/report?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Venta_Por_Nota_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingSalesByNote'));
    }
  };
};

export const setReportSalesByNoteFilters = (key = "", value) => ({
  type: SET_SALES_BY_NOTE_FILTERS,
  payload: { key, value }
});
